import useTranslation from "utils/hooks/useTranslation";
import { SvgArrow, SvgArrowLeft, SvgSaveProject, SvgSupprimer } from "./svg";
import { useCallback, useEffect, useState } from "react";
//import { useAppSelector } from "store/hooks";
import { useProject } from "utils/hooks/useProject";
import { SaveProjectPopup } from "./popups/SaveProjectPopup";
import { usePopup } from "providers/PopupProvider";
//import { scrollToWindowTop } from "utils/helpers";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import NewProjectWidget from "./NewProjectWidget";
import { ConfirmationProjectPopup } from "./popups/ConfirmationProjectPopup";
import { useAppSelector } from "store/hooks";
import Button from "./shared/button";
//import { useSalesNetwork } from "utils/hooks/useSalesNetworks";

interface NavigationButtonsProps {
    handleSubmit?: () => Promise<any>;
    handleBeforeSubmit?: () => Promise<any>;
    toogleSaveModal?: any;
    hideNext?: boolean;
    hidePrev?: boolean;
    hideSave?: boolean;
    disabled?: boolean;
    accent?: boolean;
    showIcon?: boolean;
    rightAlign?: boolean;
    generateSynthesis?: boolean;
    handleSave?: any;
    saveText?: string;
    overrideNext?: () => void;
    onClose?: () => void;
    handleSaveModalResponse?: any;
    selected?: number | undefined;
    clearSelected?: () => void;
    maxLength?: number;
    horisontalSpace?: number;
    topSpace?: number;
    showNew?: boolean;
}
const NavigationButtons: React.FC<NavigationButtonsProps> = ({
    handleSubmit, handleBeforeSubmit, toogleSaveModal, hideNext, hidePrev, hideSave, disabled,
    handleSave, saveText, overrideNext, handleSaveModalResponse, selected, clearSelected, generateSynthesis, onClose,
    maxLength = 1200, horisontalSpace = 20, accent = true, showIcon = true, rightAlign = false, topSpace = 20,
    showNew = false
}) => {

    const { t } = useTranslation();
    const { openPopup, closeLastPopup } = usePopup();
    const { isThermor } = useSalesNetwork();
    const projectStore = useAppSelector((state) => state.project);
    const { nextStep, previousStep } = useProject();
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    const [showGenerateButton, setShowGenerateButton] = useState<boolean>(false);
    const [navigateAfterSave, setNavigateAfterSave] = useState<any>(null);
    // const [data, setData] = useState({
    //     modalIsOpen: false,
    //     showGenerateButton: false
    // });

    //const brand = network?._parameters.brand;

    useEffect(() => {
        if (toogleSaveModal) {
            setModalIsOpen(true)
            setShowGenerateButton(true)
            // setData({
            //     modalIsOpen: true,
            //     showGenerateButton: true
            // })
        }
    }, [toogleSaveModal])

    useEffect(() => {
        //if (data.modalIsOpen) {
        if (modalIsOpen && sessionStorage.getItem("save_open") !== "true") {
            sessionStorage.setItem("save_open", "true")
            handleBeforeSubmit?.()
            openPopup(
                <SaveProjectPopup
                    closePopup={closeLastPopup}
                    //showGenerateButton={data.showGenerateButton}
                    showGenerateButton={showGenerateButton}
                    //handleSaveModalResponse={handleSaveModalResponse}
                    handleSaveModalResponse={(data: any)=>{
                        handleSaveModalResponse?.(data)
                        navigateAfterSave?.()
                    }}
                    onClose={() => {
                        closeLastPopup();
                        toggle();
                        onClose?.();
                        sessionStorage.removeItem("save_open")
                        
                    }}
                ></SaveProjectPopup>
            )
        }
    }, [modalIsOpen])

    const next = useCallback(() => {
        if (handleSubmit) {
            handleSubmit().then(() => {
                nextStep();
                //scrollToWindowTop();
            });
        }
    }, [nextStep, handleSubmit]);

    const previous = useCallback(() => {
        previousStep();
        //scrollToWindowTop();
    }, [previousStep]);

    const save = useCallback(() => {
        setModalIsOpen(true)
        setShowGenerateButton(false)
        // setData({
        //     modalIsOpen: true,
        //     showGenerateButton: false
        // });
    }, []);

    const toggle = useCallback(() => {
        setModalIsOpen(!modalIsOpen)
        setShowGenerateButton(false)
        // setData({
        //     modalIsOpen: !data.modalIsOpen,
        //     showGenerateButton: false
        // });
    }, [modalIsOpen]);

    const openConfirmProjectPopup = useCallback((onConfirm: any, onSave: any) => {
            openPopup(
                <ConfirmationProjectPopup
                    confirmCallBack={onConfirm}
                    saveCallback={onSave}
                    closePopup={closeLastPopup}
                ></ConfirmationProjectPopup>
            )
        }, [openPopup, closeLastPopup])
    

    const onBeforeClick = useCallback((callback: any) => {
        if(projectStore.hasChanges) {
            //alert('aaaa')
            openConfirmProjectPopup(()=>{
                callback?.()   
            }, ()=>{
                setNavigateAfterSave(()=>callback)
                save()
            });
        } else {
            callback?.() 
        }

    }, [save, openConfirmProjectPopup, projectStore.hasChanges])

    const thermorContext = (
<>
    <group data-gap="20"
        {...(hidePrev && hideSave ? { "data-justify": "end" } : {})}
    >
        {!hidePrev && <div className="button large secondary accent"
            onClick={previous}
        >
            <text data-width="auto">{t("NAV_PREVIOUS")}</text>
        </div>}
        {!hideNext && <div className={"button large secondary" + (hidePrev && hideSave ? " accent" : "")}
            {...(!disabled ? { "onClick": overrideNext || next } : {})}
        >
            <text data-width="auto">{t("NAV_NEXT")}</text>
        </div>}
    </group>

    {!hideSave && <group
        data-justify="end"
    ><div className={"button large secondary" + (accent ? " accent" : "")}
        {...(!disabled ? { "onClick": handleSave != null ? handleSave : save } : {})}
    >
            <text data-width="auto">{saveText || t("NAV_SAVE")}</text>
        </div></group>}
</>
    );

    const atlanticContext = (
        <>
        {!hidePrev && <div className="button large secondary"
            onClick={previous}
        >
            <icon data-svg-size="20" data-svg-color="white"><SvgArrowLeft /></icon>
            <text data-width="auto">{t("NAV_PREVIOUS")}</text>
        </div>}
        {!hideNext && <div className="button large secondary"
            {...(!disabled ? { "onClick": overrideNext || next } : {})}
        // onClick={overrideNext || next}
        >
            <text data-width="auto">{t("NAV_NEXT")}</text>
            <icon data-svg-size="20" data-svg-color="white"><SvgArrow /></icon>
        </div>}

        {/* {!hideSave && <div 
        className={"button large secondary" + (accent ? " accent" : "")} 

            {...(!disabled ? { "onClick": handleSave != null ? handleSave : save } : {})}
         onClick={handleSave != null ? handleSave : save}
        >
            {showIcon && <icon data-svg-size="20" data-svg-color="secondary"><SvgSaveProject /></icon>}
            <text data-width="auto" data-adaptive="desktop" >{saveText || t("NAV_SAVE")}</text>
            
            
        </div>} */}
        {!hideSave && <group data-gap="30" data-adaptive="desktop" data-max-length="140">
            <Button
                    secondary
                    large
                    fit
                    accent
                    {...( showIcon ? {"icon": <icon data-svg-size="20" data-svg-color="secondary"><SvgSaveProject /></icon>} : {})}
                    text={saveText || t("NAV_SAVE")}
                    onClick={(handleSave != null ? handleSave : save)}
                  >
                  </Button>
                </group>}
        {!hideSave && <group data-gap="30" data-adaptive="mobile">
            <Button
                    secondary
                    large
                    fit
                    accent
                    {...( showIcon ? {"icon": <icon data-svg-size="20" data-svg-color="secondary"><SvgSaveProject /></icon>} : {})}
                    text={saveText || t("NAV_SAVE")}
                    onClick={(handleSave != null ? handleSave : save)}
                  >
                  </Button>
                </group>}

        {showNew && <>
            <group data-adaptive="desktop" data-max-length="250"><NewProjectWidget onBeforeClick={onBeforeClick} /></group>
            <group data-adaptive="mobile" ><NewProjectWidget onBeforeClick={onBeforeClick} /></group>
        </>}
        </>
    );

    return <>
        {!generateSynthesis && <group data-space-vertical="20" data-direction="column" data-max-length={maxLength} data-space-horizontal={horisontalSpace} data-space-top={topSpace} >
            {(selected || clearSelected) ? <>
                <group data-space-vertical="20">
                    <text data-text-size="large">{selected && selected > 0 ? t("ACC_SELECTED", { count: selected }) : t("Vous n’avez sélectionné aucun accessoire")}</text>
                </group>
                <group data-justify={rightAlign ? "end" : "start"} data-gap="15">
                    {!hideSave && <div className="button large secondary"
                        onClick={handleSave != null ? handleSave : save}
                    >
                        {/* <icon data-svg-size="20" data-svg-color="white"><SvgArrowLeft /></icon> */}
                        <text data-width="auto">{t("ADD_QUOTE")}</text>
                    </div>}

                    <div className="button large simple secondary"
                        onClick={clearSelected}
                    >
                        <icon data-svg-size="20" data-svg-color="secondary"><SvgSupprimer /></icon>
                        <text data-width="auto">{t("DELETE_ACC_SELECTION")}</text>
                    </div>
                </group>
            </>
                :
                (
                    isThermor ?
                        <>
                            <group data-justify={rightAlign ? "end" : "start"} data-gap="15" data-wrap="no">
                                {thermorContext}
                            </group>
                        </>
                        :
                        <>
                            <group data-adaptive="desktop" data-justify={rightAlign ? "end" : "start"} data-gap="15" data-wrap="no">
                                {atlanticContext}
                            </group>
                            <group data-adaptive="mobile" data-justify={rightAlign ? "end" : "start"} data-gap="15">
                                {atlanticContext}
                            </group>
                        </>
                )

            }


        </group>}
    </>
}

export default NavigationButtons;